import { useState } from "react";
import UrlPatternsAdmin from "@/components/UrlPatternsAdmin";
import MasterDataAdmin from "@/components/MasterDataAdmin";
import JobPortalsAdmin from "@/components/JobPortalsAdmin";

const TABS = [
  { key: "master-data", label: "Master Data", desc: "Manage universal dropdown values" },
  { key: "job-portals", label: "Job Portals", desc: "Portals that drive candidate credentials" },
  { key: "url-patterns", label: "URL Patterns", desc: "Auto-classify application URLs" },
];

export default function Settings() {
  const [tab, setTab] = useState("master-data");

  return (
    <div className="space-y-6" data-testid="settings-page">
      <div>
        <h2 className="text-2xl font-semibold">Settings</h2>
        <p className="text-sm text-slate-500">Central admin controls for the SDMS platform.</p>
      </div>

      <div className="border-b border-slate-200 flex gap-2">
        {TABS.map((t) => (
          <button
            key={t.key}
            data-testid={`tab-${t.key}`}
            onClick={() => setTab(t.key)}
            className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
              tab === t.key
                ? "border-sky-600 text-sky-700"
                : "border-transparent text-slate-500 hover:text-slate-700"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="text-xs text-slate-500 -mt-4">{TABS.find((t) => t.key === tab)?.desc}</div>

      {tab === "master-data" && <MasterDataAdmin />}
      {tab === "job-portals" && <JobPortalsAdmin />}
      {tab === "url-patterns" && <UrlPatternsAdmin />}
    </div>
  );
}
